 document.addEventListener('DOMContentLoaded', function () { 
    const toggleBtn = document.getElementById('toggle-filter');
    const filterMenu = document.getElementById('filter-menu');

    // toggleBtn.addEventListener('click', function () {
    //   filterMenu.classList.toggle('open');
    //   filterMenu.classList.toggle('active');
    // });

    if (toggleBtn) {
        toggleBtn.addEventListener('click', function () {
            filterMenu.classList.toggle('open');
            filterMenu.classList.toggle('active');
        });
    }

 // Add event listener to body
document.body.addEventListener('click', function (event) {
  // Check if the click was outside the filter menu and toggle button
  if (!filterMenu.contains(event.target) && !toggleBtn.contains(event.target)) {
    filterMenu.classList.remove('open');
    filterMenu.classList.remove('active');
  }
});

  });
$(document).ready(function() {
     $('.header__inline-menu li header-menu').hover(function(){
    $(this).find('details').prop('open',true)
},function(){
    $(this).find('details').prop('open',false)
});
});


//Add to cart functionality 
// count product
const newCartLinkContentHTML = `
    <span class="svg-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-cart" viewBox="0 0 40 40">
            <path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 0 0-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0 0 20.5 6.5m3.75 5.31v-.56a3.75 3.75 0 1 0-7.5 0v.56zm-7.5 1h7.5v.56a3.75 3.75 0 1 1-7.5 0zm-1 0v.56a4.75 4.75 0 1 0 9.5 0v-.56h2.22l.71 10.67a4 4 0 0 1-3.99 4.27h-7.38a4 4 0 0 1-4-4.27l.72-10.67z"></path>
        </svg>
    </span>
    <span class="visually-hidden">Cart</span>
    <div class="cart-count-bubble">
        <span aria-hidden="true">0</span>
        <span class="visually-hidden">0 items</span>
    </div>
`;

// Function called manually from HTML/Liquid 
function manualUpdateCartCounter(count) {
    const headerCountSpan = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]'); 

    if (headerCountSpan && typeof count !== 'undefined') {
        headerCountSpan.textContent = count;
        
        const bubbleContainer = headerCountSpan.closest('.cart-count-bubble');
        if (bubbleContainer) {
             bubbleContainer.style.display = count > 0 ? 'block' : 'none';
             
             const visuallyHiddenCountElement = bubbleContainer.querySelector('.visually-hidden');
             if (visuallyHiddenCountElement) {
                visuallyHiddenCountElement.textContent = `${count} item${count === 1 ? '' : 's'}`;
             }
        }
    } else {
        console.warn("Could not find the main header cart count element for manual update.");
    }
    
    // Update the View Cart Button in the Popup 
    const viewCartButton = document.querySelector('#cart-notification-button');
    if (viewCartButton && typeof count !== 'undefined') {
        viewCartButton.textContent = `View cart (${count})`;
    }
}

function fetchCartData() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            manualUpdateCartCounter(cart.item_count);
        })
        .catch(error => console.error('Error fetching cart data:', error));
}

// show the cart notification popup and populate details 
function showCartNotification(productData) {
    const notification = document.querySelector('#cart-notification');
    if (!notification) { return; }
    
    const productWrapper = notification.querySelector('#cart-notification-product');
    if (!productWrapper) { return; }

    // required HTML structure into the empty wrapper before selecting elements
    productWrapper.innerHTML = `
      <div class="cart-notification-product__image global-media-settings">
        <img src="" alt="" width="70" height="52" loading="lazy">
      </div>
      <div>
        <p class="caption-with-letter-spacing light"></p>
        <h3 class="cart-notification-product__name h4"></h3>
        <dl></dl>
      </div>
    `;

    const titleElement = productWrapper.querySelector('.cart-notification-product__name');
    const productVendor = productWrapper.querySelector('.caption-with-letter-spacing');
    const productImage = productWrapper.querySelector('.cart-notification-product__image img');
    const viewCartButton = notification.querySelector('#cart-notification-button'); 

    if (titleElement && productData.product_title) { titleElement.textContent = productData.product_title; } 
    if (productVendor && productData.vendor) { productVendor.textContent = productData.vendor; } 
    if (productImage && productData.image) {
        const imageUrl = productData.image.startsWith('https:') ? productData.image : `https:${productData.image}`;
        productImage.src = imageUrl;
        productImage.alt = productData.product_title || 'Product Image';
    } 
    
    if (viewCartButton && typeof productData.item_count !== 'undefined') {
         viewCartButton.textContent = `View cart (${productData.item_count})`;
    }

    notification.classList.add('active', 'animate');
    notification.setAttribute('tabindex', '-1');

    const closeButton = notification.querySelector('.cart-notification__close');
    if (closeButton) {
        const closeHandler = () => {
            notification.classList.remove('active');
            closeButton.removeEventListener('click', closeHandler);
        };
        closeButton.addEventListener('click', closeHandler);
    }

    setTimeout(() => { notification.classList.remove('active'); }, 5000); 
}


// === Ajax Add to Cart Handler (Prevents redirect and manages data) ===
function addToCartAjaxHandler(event) {
    const form = event.target.closest('.add-to-cart-form');
    if (!form) return; 
    event.preventDefault(); 
    
    const submitButton = form.querySelector('.add-to-cart-btn') || form.querySelector('button[type="submit"]');
    if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Adding...'; 
    }
    
    const formData = new FormData(form); 

    fetch('/cart/add.js', { method: 'POST', body: formData })
    .then(response => {
        if (response.ok) { return response.json(); }
        return response.json().then(err => { throw new Error(err.description || 'Network response was not ok.'); });
    })
    .then(lineItemData => {
       return fetch('/cart.js')
           .then(response => response.json())
           .then(cartData => {
               return { ...lineItemData, item_count: cartData.item_count };
           });
    })
    .then(combinedData => {
       if (submitButton) {
           submitButton.disabled = false;
           submitButton.textContent = 'Add to cart'; 
       }
       
       // --- NEW LOGIC TO REPLACE OLD ICON HTML ---
       const cartLinkElement = document.querySelector('#cart-icon-bubble');
       const currentIconImage = cartLinkElement ? cartLinkElement.querySelector('.search-icon') : null;

       if (currentIconImage) {
           console.log("Replacing old cart icon HTML with new SVG version.");
           cartLinkElement.innerHTML = newCartLinkContentHTML;
       }
       // --- END NEW LOGIC ---

       const productDetailsWrapper = form.closest('.related-product-details');
       let popupData = {};

       if (productDetailsWrapper && productDetailsWrapper.getAttribute('data-product-title')) {
           popupData = {
               product_title: productDetailsWrapper.getAttribute('data-product-title'),
               vendor: productDetailsWrapper.getAttribute('data-product-vendor'),
               image: productDetailsWrapper.getAttribute('data-product-image-url'),
               item_count: combinedData.item_count
           };
       } else {
           popupData = {
               product_title: combinedData.product_title || 'Item added',
               vendor: combinedData.vendor || '',
               image: combinedData.image || '',
               item_count: combinedData.item_count 
           };
       }
       
       manualUpdateCartCounter(popupData.item_count); 
       
       // shows the popup and updates its "View Cart (X)" button
       showCartNotification(popupData); 

    })
    .catch(error => {
        console.error('Error adding product to cart:', error);
        alert('There was an error adding the product to the cart: ' + error.message);
        if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = 'Add to cart'; 
        }
    });
}

// === Initialization ===
window.addEventListener('load', (event) => {
    document.body.addEventListener('submit', addToCartAjaxHandler);
});














